import { useMutation } from "@tanstack/react-query";
import putUploadArquivo from "../queries/putUploadArquivo";

export default function usePutArquivo(onSuccess: () => void, isLoading: () => void) {
  return useMutation(
    ({token, arq, ClienteId} : {token: any, arq: any, ClienteId : number}
    ) => {
  
    const tipo = arq[0].name.split('.')

    const UPLOAD_ARQUIVO = {
      file: arq[0],
      nome: arq[0].name,
      size: arq[0].size,
      mimeType: tipo[1].toUpperCase()
    }

    return putUploadArquivo(
      token.url,
      UPLOAD_ARQUIVO,
      ClienteId,
      onSuccess,
    );
  })
}